var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font16 marginbottom20 pointer numberHeaderContainer",class:{
        darkblue: _vm.activeStep >= _vm.number,
        gray: _vm.activeStep < _vm.number || _vm.final,
    },staticStyle:{"line-height":"25px","margin-right":"12px","display":"flex","flex-flow":"column"}},[_c('div',{staticClass:"numberHeaderSubtitle",class:{
             darkblue: _vm.activeStep >= _vm.number,
            gray: _vm.activeStep < _vm.number || _vm.final,
        }},[_c('b',[_vm._v(_vm._s(_vm.title))])]),_c('span',{staticStyle:{"margin-top":"10px"}},[_vm._v(" "+_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }